export const UserRole = {
  CUSTOMER: 1,
  PROJECT_MANAGER: 2,
  DRAFTSMAN: 3,
  ADMIN: 4,
  contains: function (statusId, statuses) {
    if (statuses === undefined) {
      return false;
    }
    return !!statuses.some(s => statusId === s.id);
  },
  isSpecialist: function (roles) {
    if (roles === undefined || roles.length === 0) {
      return false;
    }
    return !!roles.some(r => UserRole.PROJECT_MANAGER === r.id || UserRole.DRAFTSMAN === r.id);
  }
}